import React, { Component } from 'react';
import PropTypes from 'prop-types';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import {
  DATA_TABLE_SOURCE_PARTNER_SALES,
  DATA_TABLE_VIEW_ID_PARTNER_SALES_ALL,
} from 'common/dataTableConstants';

import {
  dataTable,
  actionDataTableLoadItems,
  actionDataTableLoadNextPage,
} from 'client/helpers/dataTables';

import SrTable from 'client/components/SrTable';
import SrCreatePartnerSaleModal from 'client/components/SrCreatePartnerSaleModal';

import withInfiniteScroll from 'client/helpers/withInfiniteScroll';

function getDataTableSettingsFromProps() {
  const dataTableSettings = {
    itemsPropName: 'partnerSales',
    dataSource: DATA_TABLE_SOURCE_PARTNER_SALES,
    viewId: DATA_TABLE_VIEW_ID_PARTNER_SALES_ALL,
    sort: {
      'partnerSales.createdDate': 'desc',
    },
    count: 40,
  };

  return dataTableSettings;
}

@dataTable(getDataTableSettingsFromProps)
@withInfiniteScroll({
  offset: 420,
})
class SrDataTablePartnerSales extends Component {
  static propTypes = {
    partnerSales: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
    onInfiniteScrollCallbackReady: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    props.onInfiniteScrollCallbackReady(this._infiniteScrollCallback);
    this.state = {
      createPartnerSaleModalIsOpen: false,
    };
  }

  _infiniteScrollCallback = () => {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadNextPage, getDataTableSettingsFromProps(this.props));
    }
  }

  _onCreatePartnerSaleOpen = () => {
    this.setState({
      createPartnerSaleModalIsOpen: true,
    });
  }

  _onCreatePartnerSaleClose = () => {
    this.setState({
      createPartnerSaleModalIsOpen: false,
    });
  }

  _onCreatePartnerSaleModalSubmit = ({ partnerSale }) => {
    this._reloadPartnerSale(partnerSale.id);
    this._onCreatePartnerSaleClose();
  }

  _reloadPartnerSale = (partnerSaleId) => {
    const { dispatch } = this.props;

    dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_PARTNER_SALES,
      viewId: DATA_TABLE_VIEW_ID_PARTNER_SALES_ALL,
      count: 1,
      filter: {
        'partnerSales.id': partnerSaleId,
      },
    });
  }

  render() {
    const {
      partnerSales,
      dataTableApiState,
      onInfiniteScrollWrapperRef,
    } = this.props;
    const {
      createPartnerSaleModalIsOpen,
    } = this.state;

    return (
      <div ref={onInfiniteScrollWrapperRef}>
        {dataTableApiState.error && (
          <pre>Error: {dataTableApiState.error}</pre>
        )}
        <button
          type='button'
          className='button blue addEntry'
          onClick={this._onCreatePartnerSaleOpen}
        >
          register partner sale
        </button>
        <SrTable
          headers={[
            { content: 'id' },
            { content: 'name' },
            { content: 'phone' },
            { content: 'type' },
            { content: 'leases past 18 months' },
            { content: 'sales past 18 months' },
            { content: 'market' },
            { content: 'salesperson' },
            { content: 'created' },
          ]}
          rows={partnerSales.map((partnerSale) => ({
            cells: [
              { content: partnerSale.id },
              { content: partnerSale.partnerName },
              { content: partnerSale.partnerPhone },
              { content: partnerSale.partnerType },
              { content: partnerSale.leasesPastEighteenMonths },
              { content: partnerSale.salesPastEighteenMonths },
              { content: partnerSale.marketDisplayName },
              { content: partnerSale.salesRepName },
              { content: momentWithAustinTimezone(partnerSale.createdDate).format('MM/DD/YYYY') },
            ],
          }))}
        />
        {dataTableApiState.inProgress && (
          <div className='loading-ellipses left' />
        )}
        {createPartnerSaleModalIsOpen && (
          <SrCreatePartnerSaleModal
            onSubmit={this._onCreatePartnerSaleModalSubmit}
            onClose={this._onCreatePartnerSaleClose}
          />
        )}
      </div>
    );
  }
}

SrDataTablePartnerSales.displayName = 'SrDataTablePartnerSales';

export default SrDataTablePartnerSales;
